"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.translate = void 0;
//@ts-ignore
const fr_1 = __importDefault(require("../../../../lang/fr"));
//@ts-ignore
const es_1 = __importDefault(require("../../../../lang/es"));
//@ts-ignore
const ru_1 = __importDefault(require("../../../../lang/ru"));
//@ts-ignore
const ar_1 = __importDefault(require("../../../../lang/ar"));
const translations = {
    fr: fr_1.default,
    es: es_1.default,
    ru: ru_1.default,
    ar: ar_1.default,
};
const translate = (word) => {
    const selectedLang = document.getElementById("selected_lang");
    const langCode = selectedLang.value;
    if (langCode === "en") {
        return word;
    }
    const langTranslations = translations[langCode] || translations['en'];
    return langTranslations[word] || word;
};
exports.translate = translate;
